import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import React from 'react';

import type { ShippingQuoteResponse } from 'services/shippingService';
import { formatCurrencyBRL } from 'utils/currency';

import styles from 'AppRoutes/SubscriptionReview/styles';

export type SubscriptionOrderSummaryProps = {
  subtotal: number;
  shippingValue?: number | null;
  shippingPreview?: ShippingQuoteResponse | null;
  total: number;
  advanceLabel?: string;
  onAdvance: () => void;
  advanceDisabled?: boolean;
  advanceLoading?: boolean;
  /** Optional slot above the totals (e.g. CEP preview on /subscription). */
  topSlot?: React.ReactNode;
};

const SubscriptionOrderSummary = ({
  subtotal,
  shippingValue = null,
  shippingPreview = null,
  total,
  advanceLabel = 'AVANÇAR',
  onAdvance,
  advanceDisabled = false,
  advanceLoading = false,
  topSlot,
}: SubscriptionOrderSummaryProps) => (
  <Card sx={styles.card}>
    <CardContent>
      <Typography variant="h5" sx={styles.summaryTitle}>
        Resumo do Pedido
      </Typography>

      {topSlot}

      <Box sx={styles.summaryRow}>
        <Typography variant="h6">Subtotal</Typography>
        <Typography variant="h6">R$ {formatCurrencyBRL(subtotal)}</Typography>
      </Box>
      <Box sx={styles.summaryRow}>
        <Box>
          <Typography variant="h6">Frete e prazo</Typography>
          {shippingPreview && (
            <Typography variant="body2" color="text.secondary">
              {shippingPreview.deliveryTimeLabel}
            </Typography>
          )}
        </Box>
        <Typography variant="h6">
          {shippingValue !== null
            ? `R$ ${formatCurrencyBRL(shippingValue)}`
            : 'A calcular'}
        </Typography>
      </Box>
      <Box sx={styles.summaryRow}>
        <Typography variant="h6">Total</Typography>
        <Typography variant="h5">R$ {formatCurrencyBRL(total)}</Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={styles.advanceButton}
        onClick={onAdvance}
        disabled={advanceDisabled || advanceLoading}
      >
        {advanceLoading ? 'Aguarde...' : advanceLabel}
      </Button>
    </CardContent>
  </Card>
);

export default SubscriptionOrderSummary;
